import { contest } from '~/infra/api/rpc';

export const ContestStatus = {
  CONTEST_STATUS_UNSPECIFIED: 'CONTEST_STATUS_UNSPECIFIED',
  CONTEST_STATUS_PRE_DISCLOSED: 'CONTEST_STATUS_PRE_DISCLOSED',
  CONTEST_STATUS_DISCLOSED: 'CONTEST_STATUS_DISCLOSED',
  CONTEST_STATUS_OPENED: 'CONTEST_STATUS_OPENED',
  CONTEST_STATUS_CLOSED: 'CONTEST_STATUS_CLOSED',
  CONTEST_STATUS_RESULT_ANNOUNCED: 'CONTEST_STATUS_RESULT_ANNOUNCED',
} as const;
export type ContestStatus = typeof ContestStatus[keyof typeof ContestStatus];

/**
 * @throws {v.ValiError}
 */
export const convertContestStatus = (
  status: contest.ContestStatus | undefined | null
): ContestStatus => {
  if (status === undefined || status === null) {
    return ContestStatus.CONTEST_STATUS_UNSPECIFIED;
  }

  switch (status) {
    case contest.ContestStatus.CONTEST_STATUS_UNSPECIFIED:
      return ContestStatus.CONTEST_STATUS_UNSPECIFIED;
    case contest.ContestStatus.CONTEST_STATUS_PRE_DISCLOSED:
      return ContestStatus.CONTEST_STATUS_PRE_DISCLOSED;
    case contest.ContestStatus.CONTEST_STATUS_DISCLOSED:
      return ContestStatus.CONTEST_STATUS_DISCLOSED;
    case contest.ContestStatus.CONTEST_STATUS_OPENED:
      return ContestStatus.CONTEST_STATUS_OPENED;
    case contest.ContestStatus.CONTEST_STATUS_CLOSED:
      return ContestStatus.CONTEST_STATUS_CLOSED;
    case contest.ContestStatus.CONTEST_STATUS_RESULT_ANNOUNCED:
      return ContestStatus.CONTEST_STATUS_RESULT_ANNOUNCED;
    default:
      return ContestStatus.CONTEST_STATUS_UNSPECIFIED;
  }
};
